// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"IconTab_scrollbar__xdF7D","mobileScrollbar":"IconTab_mobileScrollbar__ju8nm"};